import React from 'react';
import { joinClass } from '../../helpers/component';
import useClientSize from '../../hooks/useClientSize';
import useViewport from '../../hooks/useViewport';

const FixedActions = ({ actionText, selectedDevices }) => {
  const submitText = actionText || 'Continue';
  const viewport = useViewport();
  const polaris = useClientSize('.page-footer', () => {
    document.body.classList.remove('cmp-hide');
  });
  const mobile = viewport.width <= 600 || viewport.height <= 600;
  const attachToFooter = viewport.height - polaris.top > 0;
  const fixedActionClass = (() => {
    if (mobile) return '';
    return attachToFooter ? 'fixed-action--attached' : 'fixed-action--fixed';
  })();

  return (
    <div
      className={joinClass('card-group', 'fixed-action', fixedActionClass)}
    >
      <div className="card-group__item">
        <div className="card card--action-right-at-768">
          <div className="fixed-action__wrapper auto-width">
            <div className="card__content">
              <p className="body1">
                {(selectedDevices === 0) && (
                  <span>
                    {'Select Any Device You\'d Like to Return'}
                  </span>
                )}
                {(selectedDevices > 0) && (
                  <span>
                    {`${selectedDevices} ${(selectedDevices > 1) ? 'Devices' : 'Device'} Selected`}
                  </span>
                )}
              </p>
            </div>
            <div className="card__action">
              <div className="action action--right">
                <div className="action__item">
                  <button type="submit" className="button button--primary">{submitText}</button>
                </div>
                <div className="action__item">
                  <a href="/#/devices" className="button">Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FixedActions;
